import { ECourierStatus } from '@northladder/services';

import { cn } from '../../../lib';
import {
  Button,
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '../../../ui';

import { getDealCourierStatusBadgeOptions } from './config';
import { DealStatusBadge } from './DealStatusBadge';
import { useDealCourierStatusTranslations } from './useDealCourierStatusTranslations';

interface IDealStatusHoverCardProps {
  status: ECourierStatus;
}

/**
 * -----------------------------------------------------------------------------
 * Shows the snippet of the current deal courier status item based on the courier
 * status.
 */
export function DealStatusHoverCard({ status }: IDealStatusHoverCardProps) {
  const { label, title, description } =
    useDealCourierStatusTranslations(status);

  const { className, Icon } = getDealCourierStatusBadgeOptions(status);

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <Button className="text-nav-link-text rounded-lg px-0" variant="ghost">
          <DealStatusBadge status={status} />
        </Button>
      </HoverCardTrigger>

      <HoverCardContent className="w-sm rounded-2xl border py-6">
        <div className="flex justify-between gap-4">
          <div
            className={cn(
              '!size-12 border-1 flex shrink-0 items-center justify-center rounded-full',
              className
            )}
          >
            <Icon className="size-6 block stroke-current stroke-1" />
          </div>

          <div className="space-y-3">
            <h4 className="text-md font-semibold">{label}</h4>
            <p className="text-sm">{title}</p>
            <p className="text-text-caption text-xs">{description}</p>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
